
import './App.css';
import Home from './components/Home';
import Navbar from './components/Navbar';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import Css from './components/Css';
import Js from './components/Js';
import Rct from './components/Rct';
import LangHtm from './components/LangHtm';

function App() {
  let a = ["display: flex; \n", "align-items: center;\n", "justify-content: center;"]
  let b = ["margin: 0px;\n", "padding: 0px;"]
  let c = ["padding:10px;\n", "border-radius:10px;\n", "border:none;\n", "outline:none;\n", "background: //code"]
  let d = ["const MyFunc = (para) => {\n    //code\n}"]
  let e = ["console.log(//code)"]
  return (
    <>
      <Navbar />
      <Router>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/css" element={<Css />} />
          <Route exact path="/js" element={<Js />} />
          <Route exact path="/html" element={<LangHtm />} />
          <Route exact path="/react" element={<Rct />} />
          <Route exact path="/components" element={<Css />} />
        </Routes>
      </Router>
      {/* <h1 className='text-6xl my-color text-white text-center py-3 w-4/5 m-auto font-semibold rounded-3xl my-4 border-2 border-slate-900'>Css</h1>
      <SnippeSection title="fl - Flex Align-Items Justify-Content" locate="" code={a} />
      <SnippeSection title="m0p0 - Defaults For a new Page" locate="right" code={b} />
      <SnippeSection title="btn - A Button UI Most Used By Me" locate="" code={c} />
      <h1 className='text-6xl my-color text-white text-center py-3 w-4/5 m-auto font-semibold rounded-3xl my-4 border-2 border-slate-900'>JavaScript</h1>
      <SnippeSection title="af - An Arrrow function in js" locate="right" code={d} />
      <SnippeSection title="log - A Sample console log" locate="" code={e} /> */}
    </>
  );
}

export default App;
